import React from 'react';
import { atom, createStore, useAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { Space, Switch } from 'antd';
import { isInternalUserSelector, selectedUserNameSelector } from '@store/common/selectors';

// The dashboard and its drawer have separate Providers. Keep the API usage scope
// in one store so changing either control refreshes both sets of queries.
const scopeStore = createStore();
const externalViewAtom = atom({ viewer: '', enabled: false });

export function buildApiUsageFilter(external: boolean) {
  return external
    ? ['@conviva.com', '@conviva.ai'].map((domain) => [
        {
          field: 'USER_NAME',
          key: null,
          op: 'not_contains',
          value: domain,
          display: `User Name does not contain ${domain}`,
          originalField: 'USER_NAME',
        },
      ])
    : [];
}

export function useApiUsageScope() {
  const isInternal = Boolean(useSelector(isInternalUserSelector));
  const viewer = useSelector(selectedUserNameSelector) as string;
  const [selection, setSelection] = useAtom(externalViewAtom, { store: scopeStore });
  const external = !isInternal || (selection.viewer === viewer && selection.enabled);
  return {
    isInternal,
    external,
    filter: buildApiUsageFilter(external),
    setExternal: (enabled: boolean) => setSelection({ viewer, enabled }),
  };
}

export function ApiUsageScopeToggle() {
  const { isInternal, external, setExternal } = useApiUsageScope();
  if (!isInternal) return null;
  return (
    <Space style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
      <Switch
        aria-label="View API usage as external user"
        checked={external}
        onChange={setExternal}
      />
      <span>View API usage as external user</span>
    </Space>
  );
}
